export const fileOptionsConstants = {
  MaxSizeLimitForFilterInGB: 200,
  FileOptions: {
    default: [
      {
        type: 'folder',
        options: [
          'Open',
          'Share',
          'Un Share',
          'Delete',
          'Move to',
          'Copy to',
          'Rename',
          'Details',
          'Delivery status',
          'File History',
        ],
      },
      {
        type: 'file',
        options: [
          'Download',
          'Share',
          'Un Share',
          'Delete',
          'Move to',
          'Copy to',
          'Rename',
          'Details',
          'Delivery status',
          'File History',
        ],
      },
    ],
    shared: [
      {
        type: 'folder',
        options: ['Open', 'Un Share With Me', 'Details', 'File History'],
      },
      {
        type: 'subFolder',
        options: [
          'Open',
          'Delete',
          'Move to',
          'Copy to',
          'Rename',
          'Details',
          'File History',
        ],
      },
      {
        type: 'sharedFile',
        options: ['Download', 'Un Share With Me', 'Details', 'File History'],
      },
      {
        type: 'file',
        0: ['Details', 'File History'],
        1: ['Download', 'Copy to', 'Details', 'File History'],
        3: ['Download', 'Copy to', 'Details', 'File History'],
        7: [
          'Download',
          'Delete',
          'Move to',
          'Copy to',
          'Rename',
          'Details',
          'File History',
        ],
      },
    ],
  },

  FileOptionsOutside: [
    {
      type: 'default',
      options: [
        {
          option: 'Upload Files',
          key: 'upload',
          icon: 'ppvx_icon-upload',
          renderOnlyWithPermission: [3, 7],
          renderFor: ['paypalcorp', 'gopayinc', 'adhoc'],
        },
        {
          option: 'Create Folder',
          key: 'createFolder',
          icon: 'ppvx_icon-add',
          renderOnlyWithPermission: [7],
          renderFor: ['paypalcorp', 'gopayinc', 'adhoc'],
        },
      ],
    },
    {
      type: 'folder',
      options: [
        {
          option: 'Delete',
          key: 'delete',
          icon: 'ppvx_icon-trash',
          renderOnlyWithPermission: [7],
          renderFor: ['paypalcorp', 'gopayinc', 'adhoc'],
        },
        {
          option: 'Share',
          key: 'share',
          icon: 'ppvx_icon-money-pools',
          renderOnlyWithPermission: [7],
          renderFor: ['paypalcorp', 'gopayinc'],
        },
        {
          option: 'Move to',
          key: 'move',
          icon: 'ppvx_icon-transfer',
          renderOnlyWithPermission: [7],
          renderFor: ['paypalcorp', 'gopayinc', 'adhoc'],
        },
        {
          option: 'Copy to',
          key: 'copy',
          icon: 'ppvx_icon-copy-to-clipboard',
          renderOnlyWithPermission: [7],
          renderFor: ['paypalcorp', 'gopayinc', 'adhoc'],
        },
      ],
    },
    {
      type: 'file',
      options: [
        {
          option: 'Download',
          key: 'download',
          icon: 'ppvx_icon-download',
          renderOnlyWithPermission: [1, 3, 7],
          renderFor: ['paypalcorp', 'gopayinc', 'adhoc'],
        },
        {
          option: 'Share',
          key: 'share',
          icon: 'ppvx_icon-money-pools',
          renderOnlyWithPermission: [7],
          renderFor: ['paypalcorp', 'gopayinc'],
        },
        {
          option: 'Delete',
          key: 'delete',
          icon: 'ppvx_icon-trash',
          renderOnlyWithPermission: [7],
          renderFor: ['paypalcorp', 'gopayinc', 'adhoc'],
        },
        {
          option: 'Move to',
          key: 'move',
          icon: 'ppvx_icon-transfer',
          renderOnlyWithPermission: [7],
          renderFor: ['paypalcorp', 'gopayinc', 'adhoc'],
        },
        {
          option: 'Copy to',
          key: 'copy',
          icon: 'ppvx_icon-copy-to-clipboard',
          renderOnlyWithPermission: [1, 3, 7],
          renderFor: ['paypalcorp', 'gopayinc', 'adhoc'],
        },
      ],
    },
  ],
  Icons: {
    folder: 'ppvx_icon-laptop',
    file: 'ppvx_icon-invoice',
    png: 'ppvx_icon-photo',
    asc: 'ppvx_icon-sort-ascending-alt',
    desc: 'ppvx_icon-sort-descending-alt',
  },
  Properties: [
    { name: 'Name', key: 'fileName', localizeId: 'name' },
    { name: 'Type', key: 'fileType', localizeId: 'type' },
    { name: 'Size', key: 'size', localizeId: 'size' },
    { name: 'Path', key: 'path', localizeId: 'path' },
    { name: 'Created', key: 'createdDate', localizeId: 'created' },
    { name: 'Modified', key: 'modifiedDate', localizeId: 'modified' },
  ],
  LocalizeIdForMoreOptions: [
    { name: 'Upload Files', localizeId: 'uploadFile' },
    { name: 'Create Folder', localizeId: 'createFolder' },
    { name: 'Open', localizeId: 'open' },
    { name: 'Download', localizeId: 'download' },
    { name: 'Share', localizeId: 'share' },
    { name: 'Un Share', localizeId: 'unshare' },
    { name: 'Un Share With Me', localizeId: 'unshareBySelf' },
    { name: 'Delete', localizeId: 'delete' },
    { name: 'Move to', localizeId: 'moveTo' },
    { name: 'Copy to', localizeId: 'copyTo' },
    { name: 'Rename', localizeId: 'rename' },
    { name: 'Details', localizeId: 'details' },
    { name: 'Delivery status', localizeId: 'deliveryStatus' },
    { name: 'File History', localizeId: 'fileHistory' },
  ],
  FileTypes: {
    file: 'file',
    folder: 'folder',
  },
}
